// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LoadingOverlayStyle } from "@insite/mobius/LoadingOverlay";
import { getProp } from "@insite/mobius/utilities";
import { hideLoadingOverlay } from "@rc/App/Components/Common/XngLoadingOverlay";
import { mobileTippyStyle } from "@rc/App/Components/Tippy/Style";
import { styledScrollbar } from "@rc/App/SharedStyles/sharedStyles";
import buttonVariants, { buttonSizeVariants } from "@rc/XDL/PreStyle/button";
import { xBaseTheme } from "@rc/XDL/types";
import { color, xScreen } from "@rc/XDL/Utilities";
import { css } from "styled-components";

const buttonSizeVariant = css`
    min-height: ${buttonSizeVariants.medium.height}px;
    font-size: ${buttonSizeVariants.medium.fontSize}px;
    font-weight: ${buttonSizeVariants.medium.weight};
    letter-spacing: ${buttonSizeVariants.medium.letterSpacing};
    line-height: ${buttonSizeVariants.medium.lineHeight}px;
    padding: ${buttonSizeVariants.medium.padding};
`;

export default {
    css: css`
        *:focus {
            outline: none !important;
        }

        ${hideLoadingOverlay}

        [data-tippy-root] {
            z-index: ${getProp("theme.zIndex.tippy")} !important;
        }
        ${mobileTippyStyle}

        body {
            ${styledScrollbar(8, "common.ui4")};
            overflow-x: hidden;
            // to avoid extra empty page from showing on print view
            @media print {
                vertical-align: top;
                width: 100%;
            }
            &.lock {
                overflow: hidden;
            }
            #react-app {
                min-height: 100%;
                height: initial;
            }
            #mars-footer-panel {
                max-width: 100%;
                overflow: hidden;
                background: ${color("common.ui6")};
                @media print {
                    display: none !important;
                }
            }
            button:disabled,
            a:disabled {
                opacity: 0.33;
            }
        }

        body.customer-page {
            background: white;

            .main-page {
                padding-bottom: 0;
            }

            #react-app {
                min-height: auto;
            }

            #mars-footer-panel {
                background: white;
            }
        }

        // Fix unhandledErrorModal page style
        div[data-test-selector="unhandledErrorModal"] > [class^="PageStyle"] {
            padding: 0 !important;
            background-color: transparent !important;
        }

        .primary {
            ${buttonVariants.primary.css}
            ${buttonSizeVariant}
        }

        .secondary {
            ${buttonVariants.secondary.css}
            ${buttonSizeVariant}
        }

        .embeddedServiceHelpButton .helpButton .uiButton {
            background-color: #ec001a !important;
            font-family: "Salesforce Sans", sans-serif !important;
        }
        .embeddedServiceHelpButton .helpButton .uiButton:focus {
            outline: 1px solid #666666 !important;
        }
        .embeddedServiceHelpButton .helpButton .uiButton .helpButtonLabel .message {
            background-color: #ec001a !important;
            color: white !important;
            margin: 4px 22px !important;
            font-size: 12px !important;
            padding: 0px !important;
            border: none !important;
            font-weight: bold !important;
            background-color: inherit !important;
        }
        @font-face {
            font-family: "Salesforce Sans";
            src: url("https://c1.sfdcstatic.com/etc/clientlibs/sfdc-aem-master/clientlibs_base/fonts/SalesforceSans-Regular.woff")
                    format("woff"),
                url("https://c1.sfdcstatic.com/etc/clientlibs/sfdc-aem-master/clientlibs_base/fonts/SalesforceSans-Regular.ttf")
                    format("truetype");
        }

        @media print {
            #onetrust-consent-sdk {
                display: none;
            }

            ${LoadingOverlayStyle} {
                display: block;
            }
        }
    `,
} as xBaseTheme["globalStyle"];
